import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  GenerateSegmentUploadSignedUrlMutationOptions,
  ProcessSegmentUploadMutationOptions,
  SegmentCreateMutationOptions,
  SegmentDeleteMutationOptions,
  SegmentMembershipAddMutationOptions,
  SegmentMembershipDeleteMutationOptions,
  SegmentUpdateMutationOptions,
  useGenerateSegmentUploadSignedUrlMutation,
  useProcessSegmentUploadMutation,
  useSegmentCreateMutation,
  useSegmentDeleteMutation,
  useSegmentMembershipAddMutation,
  useSegmentMembershipDeleteMutation,
  useSegmentUpdateMutation,
} from '@occc/graphql';

export const useGenerateSegmentUploadSignedUrl = (
  baseOptions?: GenerateSegmentUploadSignedUrlMutationOptions,
) => useMutation(useGenerateSegmentUploadSignedUrlMutation, baseOptions);

export const useProcessSegmentUpload = (baseOptions?: ProcessSegmentUploadMutationOptions) =>
  useMutation(useProcessSegmentUploadMutation, baseOptions);

export const useCreateSegment = (baseOptions: SegmentCreateMutationOptions) =>
  useMutation(useSegmentCreateMutation, baseOptions);

export const useUpdateSegment = (baseOptions?: SegmentUpdateMutationOptions) =>
  useMutation(useSegmentUpdateMutation, baseOptions);

export const useDeleteSegment = (baseOptions: SegmentDeleteMutationOptions) =>
  useMutation(useSegmentDeleteMutation, baseOptions);

export const useAddMembershipToSegment = (baseOptions: SegmentMembershipAddMutationOptions) =>
  useMutation(useSegmentMembershipAddMutation, baseOptions);

export const useRemoveMembershipFromSegment = (
  baseOptions: SegmentMembershipDeleteMutationOptions,
) => useMutation(useSegmentMembershipDeleteMutation, baseOptions);
